module.exports = __webpack_public_path__ + "img/old-structure-management.6ae42d2b.png";